import { render } from "./historytab.vue?vue&type=template&id=4ce230c2"
import script from "./historytab.vue?vue&type=script&lang=js"
export * from "./historytab.vue?vue&type=script&lang=js"

import "./historytab.vue?vue&type=style&index=0&id=4ce230c2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__